export const selectCasesState = (state) => state.cases;
